export * from '../types';

import RealtimeClient, { CreateRealtimeClientType } from './RealtimeClient';

export default RealtimeClient;

export type {
  CreateRealtimeClientType,
}
